import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .sticky-header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    background-color: ${colors.WHITE};
    position: fixed;
    top: 0;
    left: 0;
    border-bottom: 4px solid ${colors.G2};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  }

  .details {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  @media (min-width: ${screen.lgMin}) {
    .details {
      width: 1160px;
    }
  }

  .left-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    padding: 8px 0 8px 25px;
  }

  @media (min-width: ${screen.lgMin}) {
    .left-container {
      padding-left: 0;
    }
  }

  .right-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
    width: 50%;
    padding: 8px 25px 8px 0;
  }

  @media (min-width: ${screen.lgMin}) {
    .right-container {
      padding-right: 0;
    }
  }

  .primary-photo {
    width: 116px;
    height: 72px;
    border-radius: 8px;
    margin-right: 14px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .primary-details,
  .price {
    font-size: 18px;
    font-weight: 600;
    color: ${colors.BLACK};
  }

  .secondary-details,
  .monthly-payment {
    font-size: 16px;
    color: ${colors.BLACK};
  }
`;
